import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { roundUpToTwoDecimals } from 'components/localisation/FormatPrice/utils/roundUpToTwoDecimals';
import type { Money } from 'types/product/Money';
import { getSavingsRate } from 'utils/getSavingsRate';

interface DiscountBadgeProps {
  price: Money;
  compareAtPrice: Money;
}

export function DiscountBadge({ price, compareAtPrice }: DiscountBadgeProps) {
  const discountPercentage = getSavingsRate({
    anchor: compareAtPrice.amount,
    price: price.amount,
  });

  const rounded = roundUpToTwoDecimals(price.amount);
  const [integer, fraction] = (
    rounded % 1 === 0 ? String(rounded) : rounded.toFixed(2)
  ).split('.');

  return (
    <Box
      position="absolute"
      top={{ base: 'xs', md: 'sm' }}
      right={{ base: 'xs', md: 'sm' }}
      zIndex={2}
      bgColor="gray.50"
      borderRadius="full"
      width={{ base: '110px', sm: '130px' }}
      height={{ base: '110px', sm: '130px' }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      color="gray.600"
      boxShadow="0 0 0 1px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.02), 0px 1px 4px 0px rgba(0, 0, 0, 0.06), 0px 6px 24px 0px rgba(0, 0, 0, 0.06)"
      pointerEvents="none"
    >
      <VStack spacing={0} gap={{ base: '5xs', md: '2px' }}>
        <Text size={{ base: 'overline2', md: 'overline' }} mt="5xs">
          Price Cut
        </Text>

        <Flex alignItems="flex-start" justifyContent="center" pr="5xs">
          <Text size="h5" mt={{ base: '2px', md: '5xs' }} mr="1px">
            $
          </Text>
          <Text size={{ base: 'h1', md: 'h2' }} whiteSpace="nowrap">
            {integer}
            {fraction && (
              <Text as="span" size="title3">
                .{fraction}
              </Text>
            )}
          </Text>
        </Flex>

        <Text size="title3" whiteSpace="nowrap" mt="-5xs">
          -{discountPercentage}%
        </Text>
      </VStack>
    </Box>
  );
}
